<template>
  <v-card
    class="Member rounded pa-2"
    color="surface-primary"
    flat
    active
    :class="{ item: profile.id !== member.id, 'ignore-draggable-elements': profile.id === member.id }"
    :style="{ cursor: profile.id !== member.id && isCurrentUserPm ? 'grab' : '' }"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <v-row align="center" no-gutters>
      <v-col>
        <div :class="{ 'user-in-group': profile.id === member.id }" class="d-flex align-center">
          <MemberDetailsModal
            :member="member"
            :is-in-pm-group="group.isPm"
            :mnemo="mnemo"
            @update:member="$emit('update:member', $event)"
          />
        </div>
      </v-col>
      <v-col class="align-self-start ignore-draggable-elements" cols="auto">
        <!-- BUTTON DELETE MEMBER -->
        <MemberDeleteDialog v-if="isCurrentUserPm && member.id !== profile.id" :member="member" />
      </v-col>
    </v-row>
    <v-row v-if="member.isRedactedForInactivity" class="mt-1" no-gutters>
      <v-col class="text-caption text-text-secondary ignore-draggable-elements bg-surface-warning-subtle px-2 py-1 mr-1 rounded-sm mt-1 w-100">
        {{$t('project.members.Member.isRedactedForInactivity')}}
      </v-col>
    </v-row>
    <v-row v-else-if="!member.isActive && isCurrentUserPm" class="mt-1" no-gutters>
      <v-col>
        <!-- NOT ACTIVATED -->
        <AppTooltip>
          <template #activator="{ props }">
            <v-btn
              v-bind="props"
              :disabled="sendGlobalReminderLoading"
              variant="flat"
              block
              class="text-caption ignore-draggable-elements rounded-sm button-activate-account"
              @click="sendEmail"
            >
              <div class="d-flex">
                <app-material-icon
                  name="warning"
                  size="xs"
                  color="icon-warning"
                  class="mr-2"
                />
                <span class="align-self-end">{{ $t('project.members.Member.accountNotActivated') }}</span>
              </div>
              <app-material-icon
                name="mail"
                size="xs"
                />
            </v-btn>
          </template>
          <span>{{$t('project.members.Member.sendFollowUpEmail')}}</span>
        </AppTooltip>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import AppTooltip from '@/common/AppTooltip.vue'
import { toast } from '@/common/utils/toast'

import MemberDeleteDialog from './dialogs/MemberDeleteDialog.vue'
import MemberDetailsModal from './dialogs/MemberDetailsDialog.vue'

export default {
  name: 'Member',
  components: {
    MemberDetailsModal,
    MemberDeleteDialog,
    AppTooltip,
  },
  props: {
    member: Object,
    group: Object,
    mnemo: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      hover: false,
    }
  },
  computed: {
    ...mapState('user', ['profile']),
    ...mapGetters('room', ['isCurrentUserPm']),
    ...mapState('groups', ['sendGlobalReminderLoading']),
  },
  methods: {
    ...mapActions('groups', ['CHASE_MEMBER']),
    sendEmail () {
      this.CHASE_MEMBER(this.member.id)
        .then(() => {
          toast.success(this.$t('project.members.Member.messages.successChaseUser'))
        })
        .catch(error => {
          if (error.response?.status === 403 && error.response?.data?.errorCode === 'ERR_WAIT_BEFORE_CHASING') {
            toast.error(this.$t('project.members.Member.messages.errorChaseUserWait'))
          } else if (error.response?.status === 409 && error.response?.data?.errorCode === 'ERR_USER_ALREADY_ACTIVE') {
            toast.error(this.$t('project.members.Member.messages.errorChaseUserAlreadyActive'))
          } else {
            toast.error(this.$t('project.members.Member.messages.errorChaseUser'))
          }
        })
    },
  },
}
</script>

<style scoped lang="scss">
.user-in-group {
  color: rgb(var(--v-theme-primary));
  font-weight: 800 !important;
}

.Member {
  border: 1px solid rgb(var(--v-theme-border-primary));
}

.Member:not(:last-child) {
  margin-bottom: 8px;
}

.Member.sortable-ghost,
.Member.sortable-chosen {
  user-select: none;
  border: 2px dashed rgb(var(--v-theme-border-primary)) !important;
}

.Member.sortable-drag {
  border: 2px solid rgb(var(--v-theme-border-info-bold)) !important;
  opacity: 1 !important;
}

.button-activate-account {
  height: 30px;
  background-color: rgb(var(--v-theme-surface-warning-subtle));
  color: rgb(var(--v-theme-text-secondary));

  :deep(.v-btn__overlay) {
    transition: opacity 0s;
  }

  :deep(.v-btn__content) {
    justify-content: space-between;
    flex: 1;
  }
}

:deep(.button-activate-account:hover .v-btn__overlay) {
  opacity: 1 !important;
  color: rgba(var(--v-theme-surface-hover));
}
</style>
